<template>
  <div>
    <NoneData
      v-if="!commodityList.length"
      style="background: #ffffff"
      propsText="该店铺所选时段内无关联品牌信息"
      :height="6"
    />
    <div class="shop-commodity" v-else>
      <form action="/"></form>
      <div class="carrier-list-data">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多数据了哦~"
          @load="getTableData"
        >
          <router-link
            v-for="(item, index) of brandList"
            :key="item.itemId"
            :to="`/brand/${item.brandId}`"
            class="new_item-default"
          >
            <div class="new_box">
              <div class="top_box">
                <div class="new_commodity-sort">{{ index + 1 }}</div>
                <avatar class="new_item-icon" :text="item.title" :src="item.imageUrl"></avatar>
                <div class="text">
                  <div class="name">
                    {{item.title}}
                  </div>
                  <div class="num">
                    <div class="num_box" v-for="val in item.category">{{val.name}}</div>
                  </div>
                </div>
              </div>
              <div class="bottom_box">
                <div class="box_pay">
                  <div class="txt_1">关联达人</div>
                  <div class="txt_2">{{ item.anchorCount }}</div>
                </div>
                <div class="box_pay">
                  <div class="txt_1">关联销量</div>
                  <div class="txt_2">{{item.salesVolume}}</div>
                </div>
                <div class="box_pay">
                  <div class="txt_1">销售额</div>
                  <div class="txt_2" style="color: #ff5000">¥{{item.sales}}</div>
                </div>
              </div>
            </div>
          </router-link>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import avatar from '@/components/Avatar.vue'
export default {
  props: { query: Object },
  data() {
    return {
      params: {
        pageNum: 1,
        pageSize: 10,
        order: "desc",
        sort: "sales",
        searchText: "",
      },
      loading: true,
      count: 0,
      commodityList: [],
    };
  },
  watch: {
    query: {
      deep: true,
      immediate: true,
      handler() {
        this.params.pageNum = 1;
        this.params = {
          ...this.params,
          ...this.$props.query,
        };
        this.count = 0;
        this.commodityList = [];
        this.getTableData();
      },
    },
  },
  computed: {
    finished: (_this = this) => _this.count === _this.commodityList.length,
    brandList() {
        return this.commodityList.map(item => {
         return  {...item,
            title: item.brand?.name || '-',
            imageUrl: item.brand?.image,
            category: item.category,
            salesVolume:this.$retainWan(item.salesVolume) || '-',//销量
            sales:this.$retainWan(item.sales) || '-',//销售额
            anchorCount: item.anchorCount || '-',//关联达人

        }
        })
    }
  },
  methods: {
    async getTableData() {
      const res = await this.$api
        .get(`/v2/shop/${this.$route.params.id}/brandStatistic`, {
          params: this.params,
        })
        .catch((_) => {});
      if (res.data.data) {
        // 如果页码等于一  第一次加载或更换日期
        this.commodityList =
          this.params.pageNum === 1
            ? res.data.data
            : this.commodityList.concat(res.data.data);
        this.params.pageNum++;
        this.count = res?.data?.paging?.count || 0;
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
/deep/.van-search__content {
  border-radius: 10px;
}
.loading {
  font-size: 0.24rem;
  color: #fbfafa;
  padding: 0.5rem 0.3rem;
  text-align: center;
}
.new_item-default {
  font-family: number-bold, sans-serif;
  padding: 18px 12px;
  background: #fff;
  box-shadow: 0px 0px 8px 8px rgba(168, 178, 197, 0.08);
  margin-bottom: 12px;
  display: flex;
  width: 375px;
  .new_box {
    .top_box {
      display: flex;
      position: relative;
      .new_commodity-sort {
        position: absolute;
        top: -5px;
        color: #2877ff;
        text-align: center;
        font-family: Roboto;
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: 12px; /* 120% */
      }
      .new_item-icon {
        margin-left: 10px;
        margin-right: 8px;
        width: 60px;
        height: 60px;
        border-radius: 8px;
        border: 1px solid #efefef;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text {
        display: flex;
        flex-direction: column;
        justify-content: space-around;


        .name {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 267px;
          height: 20px;
          color: var(--, #252e39);
          font-family: PingFang SC;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
        .num {
          display: flex;
          .num_box {
            padding: 1px 4px;
            color: #2877ff;
            text-align: center;
            font-family: PingFang SC;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            border-radius: 14px;
            background-color: rgba(55, 121, 246, 0.1);
            margin-right: 8px;
          }
        }
      }
    }
    .bottom_box {
      margin-top: 18px;
      display: flex;
      height: 36px;
      .box_pay {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .txt_1 {
          color: #8e9aae;
          text-align: center;
          font-family: PingFang SC;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 12px; /* 100% */
        }
        .txt_2 {
          color: #141b27;
          text-align: center;
          font-family: Roboto;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 16px; /* 100% */
        }
      }
    }
  }
}
</style>
